<template>
  <div>
    <div class="nav" @click="playAudio">
      <!-- <div class="touch-box">
        <div class="touch" v-for="(item, index) in 5" :key="index" @click="goTo(tabbar[index])"></div>
      </div> -->
      <router-link to="/home">
        <div class="yuan">
          <img style="width: 28px;height:20px" :src="currentRoute === 'home2'
            ? require('../assets/home/ts1.png')
            : require('../assets/home/t1.png')
            " alt="" :class="[currentRoute === 'home2' ? 'active' : '']" />

          <div class="text">个人</div>
        </div>
        <div class="select_icon">
          <div class="b_img">
            <img style="width: 100%;: 100%;height: 100%;" src="../assets/home/ss.png" alt="">
          </div>
          <div class="t_text">
            <img style="width: 28px;height:20px" :src="currentRoute === 'home2'
              ? require('../assets/home/ts1.png')
              : require('../assets/home/t1.png')
              " alt="" :class="[currentRoute === 'home2' ? 'active' : '']" />

            <div class="text">个人</div>
          </div>
        </div>
      </router-link>

      <router-link to="/share">
        <div class="yuan">
          <img style="width: 23px;height:25px" :src="currentRoute === 'share'
            ? require('../assets/home/ts2.png')
            : require('../assets/home/t2.png')
            " alt="" :class="[currentRoute === 'share' ? 'active' : '']" />

          <div class="text">分享</div>
        </div>
        <div class="select_icon">
          <div class="b_img">
            <img style="width: 100%;: 100%;height: 100%;" src="../assets/home/ss.png" alt="">
          </div>
          <div class="t_text">
            <img style="width: 23px;height:25px" :src="currentRoute === 'share'
              ? require('../assets/home/ts2.png')
              : require('../assets/home/t2.png')
              " alt="" :class="[currentRoute === 'share' ? 'active' : '']" />

            <div class="text">分享</div>
          </div>
        </div>
      </router-link>
      <router-link to="/">
        <div class="yuan">
          <img style="width: 28px;height:25px" :src="currentRoute === 'home'
            ? require('../assets/home/ts3.png')
            : require('../assets/home/t3.png')
            " alt="" :class="[currentRoute === 'home' ? 'active' : '']" />

          <div class="text">首页</div>
        </div>
        <div class="select_icon">
          <div class="b_img">
            <img style="width: 100%;: 100%;height: 100%;" src="../assets/home/ss.png" alt="">
          </div>
          <div class="t_text">
            <img style="width: 28px;height:25px" :src="currentRoute === 'home'
              ? require('../assets/home/ts3.png')
              : require('../assets/home/t3.png')
              " alt="" :class="[currentRoute === 'home' ? 'active' : '']" />

            <div class="text">首页</div>
          </div>
        </div>
      </router-link>
      <router-link to="/knapsack">
        <div class="yuan">
          <img style="width: 24px;height:21px" :src="currentRoute === 'knapsack'
            ? require('../assets/home/ts4.png')
            : require('../assets/home/t4.png')
            " alt="" :class="[currentRoute === 'knapsack' ? 'active' : '']" />

          <div class="text">背包</div>
        </div>
        <div class="select_icon">
          <div class="b_img">
            <img style="width: 100%;: 100%;height: 100%;" src="../assets/home/ss.png" alt="">
          </div>
          <div class="t_text">
            <img style="width: 24px;height:21px" :src="currentRoute === 'knapsack'
              ? require('../assets/home/ts4.png')
              : require('../assets/home/t4.png')
              " alt="" :class="[currentRoute === 'knapsack' ? 'active' : '']" />
            <div class="text">背包</div>
          </div>
        </div>
      </router-link>

      <router-link to="/recharge">
        <div class="yuan">
          <img style="width: 26px;height:26px" :src="currentRoute === 'recharge'
            ? require('../assets/home/ts5.png')
            : require('../assets/home/t5.png')
            " alt="" :class="[currentRoute === 'recharge' ? 'active' : '']" />

          <div class="text">充值</div>
        </div>
        <div class="select_icon">
          <div class="b_img">
            <img style="width: 100%;: 100%;height: 100%;" src="../assets/home/ss.png" alt="">
          </div>
          <div class="t_text">
            <img style="width: 26px;height:26px" :src="currentRoute === 'recharge'
              ? require('../assets/home/ts5.png')
              : require('../assets/home/t5.png')
              " alt="" :class="[currentRoute === 'recharge' ? 'active' : '']" />

            <div class="text">充值</div>
          </div>
        </div>
      </router-link>
      <!-- <div class="top-img"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentRoute: this.$route.name,
      tabbar: [
        {
          name: 'knapsack',
          path: '/knapsack'
        },
        {
          name: 'share',
          path: '/share'
        },
        {
          name: 'home',
          path: '/'
        },
        {
          name: 'recharge',
          path: '/recharge'
        },
        {
          name: 'home2',
          path: '/home'
        }
      ]
    };
  },
  watch: {
    $route(to) {
      this.currentRoute = to.name;
    },
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    },
    playAudio() {
      this.$soundPlay("click")
    },
  },
};
</script>

<style lang="scss" scoped>
// @media (max-width: 550px) {
//   .nav {
//     height: 65px !important;
//     font-size: 10px !important;
//     position: fixed !important;
//     bottom: 0 !important;
//   }
//   .yuan {
//     width: 50px !important;
//     height: 50px !important;
//   }
//   .btn_icon {
//     width: 42px*0.7 !important;
//     height: 48px*0.7 !important;
//     margin: 0 auto;
//   }
// }
.btn_icon {
  width: 42px;
  height: 48px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
  }
}

.select_icon {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: relative;

  .b_img {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
  }

  .t_text {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translate(-50%, -50%);

    .text {
      padding-top: 7px;
      color: #A7AFC0;
    }
  }
}

.yuan {
  width: 70px;
  height: 70px;
  opacity: 1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;

  .text {
    padding-top: 4px;
  }

  // &:hover {
  //   background: rgba(58, 151, 228, 0.1);
  // }
}

.yuan .iconfont {
  font-size: 26px;
  color: #727477;
  margin-bottom: 4px;
}

.yuan .iconfont.active {
  color: #b69eff;
}

.nav {
  width: 100%;
  padding-top: 2px;
  display: flex;

  // background-color: #0F192F;

  background-image: url("../assets/home/bottom.png");

  img {
    height: 23.5* 1.1px;
    width: 25* 1.1px;

    @media only screen and (max-width: 430px) {
      width: 10.67vw;
      height: 8.53vw;
    }
  }

  a {
    display: inline-block;
    width: 20%;
    // font-weight: bold;
    // color: #727477;
    color: #A7AFC0;
    font-size: 14px;
    position: relative;
    border-right: 2px solid #21293B;

    &:last-child {
      border-right: none;
    }

    &.router-link-exact-active {
      .yuan {
        opacity: 0;
      }

      // color: #fff;
      .select_icon {
        opacity: 1;
      }

      .yuan {}

      svg {
        path {
          fill: #fff;
        }
      }
    }

    &.router-link-exact-active::before {
      // position: absolute;
      // bottom: 10px;
      // left: 0;
      // content: "";
      // width: 100%;
      // height: 100%;
      // background-repeat: no-repeat;
      // background-position: center bottom;
      // background-size: 17.07 * 4.2px 15.47 * 4.2px;
      // background-image: url("../assets/images/app_ft_4.png");
      // background-image: url("../assets/home/ss.png");
      // z-index: 999;
      // opacity: 0;
    }
  }
}

.top-img {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 14.8 * 4.2px;
  background-size: 100% 100%;
  background-image: url("../assets/images/app_ft_2.png");
  // z-index: -1;
}

// 新样式
.tabbar {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 98;
  width: 100 * 4.2px;
  height: 23.73 * 4.2px;
  font-family: "Alimama ShuHeiTi", serif;
  background-position: center bottom;
  background-size: 100% 100%;
  background-image: url("../assets/images/app_ft_1.png");
}

.tabbar.small-dialog-index {
  z-index: -1;
}

.tabbar .nav-box {
  position: relative;
  width: 100%;
  height: 100%;
}

.tabbar .nav-box .touch-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.tabbar .nav-item {
  float: left;
  width: 20 * 4.2px;
  height: 17.33 * 4.2px;
  padding-top: 1.33 * 4.2px;
}

.tabbar .nav-item .icon {
  width: 10.67 * 4.2px;
  height: 8.53 * 4.2px;
  margin-bottom: 1.33 * 4.2px;
}

.tabbar .nav-item.sel {
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 17.07 * 4.2px 15.47 * 4.2px;
  background-image: url("../assets/images/app_ft_4.png");
}

.tabbar .nav-item.sel .name {
  opacity: 1;
}

.tabbar .nav-item .name {
  opacity: 0.5;
  font-size: 3.33 * 4.2px;
  font-weight: 400;
  color: #fff;
  margin-top: -1.07 * 4.2px;
}

#nprogress {
  pointer-events: none;
}

#nprogress .bar {
  background: #29d;

  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;

  width: 100%;
  height: 0.27 * 4.2px;
}

/* Fancy blur effect */
#nprogress .peg {
  display: block;
  position: absolute;
  right: 0px;
  width: 13.33 * 4.2px;
  height: 100%;
  -webkit-box-shadow: 0 0 1.33 * 4.2px #29d, 0 0 0.67 * 4.2px #29d;
  box-shadow: 0 0 1.33 * 4.2px #29d, 0 0 0.67 * 4.2px #29d;
  opacity: 1;

  -webkit-transform: rotate(3deg) translate(0px, -0.53 * 4.2px);
  -ms-transform: rotate(3deg) translate(0px, -0.53 * 4.2px);
  transform: rotate(3deg) translate(0px, -0.53 * 4.2px);
}

.touch-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
}

.touch {
  // position: absolute;
  width: 70px;
  height: 100%;
  opacity: 1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
}
</style>